import { useSearchParams } from 'react-router-dom';
import ChatRoom from './components/ChatRoom';
import WelcomeSection from './components/WelcomeSection';

const MobiPage = () => {
  const [searchParams] = useSearchParams();

  const roomId = Number(searchParams.get('roomId'));

  return (
    <div className='relative flex w-screen items-center justify-center bg-[url(/svg/mobi-background.svg)] bg-cover bg-[100%_100%] bg-no-repeat'>
      {roomId ? <ChatRoom roomId={roomId} /> : <WelcomeSection />}
    </div>
  );
};

export default MobiPage;
